import Image from 'next/image';
import { env } from '@zopauk/nextjs-env';
import type { MenuItem } from '@zopauk/web-ui';

const personalNavItems: MenuItem[] = [
  {
    children: [
      {
        children: [
          {
            attributes: {
              'data-automation': 'Current_account.Biscuit.topBar.Menu',
              href: '/current-account',
            },
            text: 'Current account',
          },
        ],
        text: 'Everyday banking',
      },
      {
        children: [
          {
            attributes: {
              'data-automation': 'Cashback.Biscuit.topBar.Menu',
              href: '/current-account/cashback',
            },
            text: 'Cashback',
          },
          {
            attributes: {
              'data-automation': 'Interest_on_Balance.Biscuit.topBar.Menu',
              href: '/current-account/interest',
            },
            text: 'Interest on balance',
          },
          {
            attributes: {
              'data-automation': 'Zopa_AI.Biscuit.topBar.Menu',
              href: '/current-account/ai',
            },
            text: 'Zopa AI',
          },
          {
            attributes: {
              'data-automation': 'Travel.Biscuit.topBar.Menu',
              href: '/current-account/travel',
            },
            text: 'Travel',
          },
        ],
        text: 'Features',
      },
      {
        children: [
          {
            attributes: {
              'data-automation': 'Apply_for_an_account.Biscuit.topBar.Menu',
              href: '/open-bank-account-online',
            },
            text: 'Apply for an account',
          },
          {
            attributes: {
              'data-automation': 'Switch_to_Zopa.Biscuit.topBar.Menu',
              href: '/current-account/switch',
            },
            text: 'Switch to Zopa',
          },
        ],
        text: 'More',
      },
    ],
    attributes: {
      'data-automation': 'Biscuit.topBar.Button',
    },
    text: 'Biscuit',
  },
  {
    children: [
      {
        children: [
          {
            attributes: {
              'data-automation': 'loans.Borrow.topBar.Menu',
              href: '/loans',
            },
            text: 'Personal loan',
          },
        ],
        text: 'Loans',
      },
      {
        children: [
          {
            attributes: {
              'data-automation': 'Credit_card.Borrow.topBar.Menu',
              href: '/credit-card',
            },
            text: 'Credit card',
          },
        ],
        text: 'Credit cards',
      },
      {
        children: [
          {
            attributes: {
              'data-automation': 'Car_finance.Borrow.topBar.Menu',
              href: '/car-finance',
            },
            text: 'Compare car finance',
          },
          {
            attributes: {
              'data-automation': 'hp.Borrow.topBar.Menu',
              href: '/car-finance/hp',
            },
            text: 'Hire purchase (HP)',
          },
          {
            attributes: {
              'data-automation': 'pcp.Borrow.topBar.Menu',
              href: '/car-finance/pcp',
            },
            text: 'Personal contract purchase (PCP)',
          },
          {
            attributes: {
              'data-automation': 'Car_loan.Borrow.topBar.Menu',
              href: '/loans/car-loans',
            },
            text: 'Car loan',
          },
        ],
        text: 'Car finance',
      },
      {
        children: [
          {
            attributes: {
              'data-automation': 'Retail_Finance.Borrow.topBar.Menu',
              href: '/retail-finance',
            },
            text: 'Retail finance',
          },
        ],
        text: 'Retail finance',
      },
    ],
    image: (
      <Image
        alt="Young man wearing glasses, feeling good and grinning enthusiastically"
        src="/images/zopa-feel-good-man.png"
        loading="lazy"
        height="280"
        width="300"
      />
    ),
    attributes: {
      'data-automation': 'Borrow.topBar.Button',
    },
    text: 'Borrow',
  },
  {
    children: [
      {
        children: [
          {
            attributes: {
              'data-automation': 'Savings_Accounts.Save.topBar.Menu',
              href: '/savings',
            },
            text: 'Savings account',
          },
          {
            attributes: {
              'data-automation': 'Easy_Access.Save.topBar.Menu',
              href: '/savings/easy-access-savings',
            },
            text: 'Easy access',
          },
          {
            attributes: {
              'data-automation': 'Limited_Access.Save.topBar.Menu',
              href: '/savings/limited-access-savings',
            },
            text: 'Limited access',
          },
          {
            attributes: {
              'data-automation': 'Fixed_Term.Save.topBar.Menu',
              href: '/savings/fixed-term-savings',
            },
            text: 'Fixed term',
          },
        ],
        text: 'Savings',
      },
      {
        children: [
          {
            attributes: {
              'data-automation': 'Cash_ISA.Save.topBar.Menu',
              href: '/isas/cash-isa',
            },
            text: 'Cash ISA',
          },
          {
            attributes: {
              'data-automation': 'Fixed_Term_Cash.Save.topBar.Menu',
              href: '/isas/cash-isa/fixed-term',
            },
            text: 'Fixed term Cash ISA',
          },
          {
            attributes: {
              'data-automation': 'Stocks_and_Shares.Save.topBar.Menu',
              href: '/investing/stocks-and-shares-isa',
            },
            text: 'Stocks & Shares ISA',
          },
        ],
        text: 'ISAs',
      },
    ],
    image: (
      <Image
        alt="Young woman in a sweater looking out and smiling with a padlock key in the background"
        src="/images/savings-feature-image.png"
        loading="lazy"
        height="260"
        width="238"
      />
    ),
    attributes: {
      'data-automation': 'Save.topBar.Menu',
    },
    text: 'Save',
  },
  {
    children: [
      {
        attributes: {
          'data-automation': 'Investing.Invest.topBar.Menu',
          href: '/investing',
        },
        text: 'Investing',
      },
      {
        attributes: {
          'data-automation': 'Stocks_and_Shares.Invest.topBar.Menu',
          href: '/investing/stocks-and-shares-isa',
        },
        text: 'Stocks & Shares ISA',
      },
      {
        attributes: {
          'data-automation': 'Investing_For_Beginners.Invest.topBar.Menu',
          href: '/blog/article/investing-for-beginners',
        },
        text: 'Investing For Beginners',
      },
      {
        attributes: {
          'data-automation': 'Investing_Guides.Invest.topBar.Menu',
          href: '/blog/category/investing',
        },
        text: 'Investing Guides',
      },
    ],
    attributes: {
      'data-automation': 'Invest.topBar.Menu',
    },
    text: 'Invest',
  },
  {
    children: [
      {
        attributes: {
          'data-automation': 'About.About.topBar.Menu',
          href: '/about',
        },
        text: 'About Zopa',
      },
      {
        attributes: {
          'data-automation': 'Our_Board.About.topBar.Menu',
          href: '/about/board',
        },
        text: 'Our board',
      },
      {
        attributes: {
          'data-automation': 'Our_Leadership.About.topBar.Menu',
          href: '/about/leadership',
        },
        text: 'Our leadership team',
      },
      {
        attributes: {
          'data-automation': 'Fintech_Pledge_2025.topBar.Menu',
          href: '/pledge2025',
        },
        text: 'Fintech Pledge 2025',
      },
      {
        attributes: {
          'data-automation': 'Awards.About.topBar.Menu',
          href: '/about/awards',
        },
        text: 'Awards',
      },
      {
        attributes: {
          'data-automation': 'Blog.topBar.Menu',
          href: '/blog',
        },
        text: 'Blog',
      },
      {
        attributes: {
          'data-automation': 'Careers.About.topBar.Menu',
          href: 'https://careers.zopa.com/',
        },
        text: 'Careers',
      },
      {
        attributes: {
          'data-automation': 'Press_office.About.topBar.Menu',
          href: '/about/press',
        },
        text: 'Press office',
      },
    ],
    image: (
      <Image
        alt="Two hands coming together in a high five between a man and a woman"
        src="/images/upl-we-are-zopa.png"
        loading="lazy"
        height="280"
        width="282"
      />
    ),
    attributes: {
      'data-automation': 'About.topBar.Menu',
    },
    text: 'About',
  },
  {
    children: [
      {
        attributes: {
          'data-automation': 'Retail_Finance.Help.topBar.Menu',
          href: '/help/retail-finance',
        },
        text: 'Retail finance',
      },
    ],
    attributes: {
      'data-automation': 'Help.topBar.Menu',
      href: '/help',
    },
    text: 'Help',
  },
  {
    children: [
      {
        attributes: {
          'data-automation': 'Consumer_Finance.Partnerships.topBar.Menu',
          href: '/consumer-finance',
        },
        text: 'Consumer finance',
      },
      {
        attributes: {
          'data-automation': 'Embedded_Lending.Partnerships.topBar.Menu',
          href: '/embedded-lending',
        },
        text: 'Embedded lending',
      },
      {
        attributes: {
          'data-automation': 'Retail_Finance.Partnerships.topBar.Menu',
          href: '/retail-finance',
        },
        text: 'Retail finance',
      },
      {
        attributes: {
          'data-automation': 'Auto_Finance.Partnerships.topBar.Menu',
          href: '/auto-finance',
        },
        text: 'Auto finance',
      },
    ],
    image: (
      <Image
        alt="A hand holding a mobile phone displaying a credit card approval message"
        src="/images/b2b-thanks-for-choosing-zopa-phone.png"
        loading="lazy"
        height="280"
        width="280"
      />
    ),
    attributes: {
      'data-automation': 'Partnerships.topBar.Menu',
    },
    text: 'Partnerships',
  },
];

const businessNavItems: MenuItem[] = [
  {
    attributes: {
      'data-automation': 'Business_Payments.topBar.Button',
      href: '/business/payments',
    },
    text: 'Payments',
  },
  {
    attributes: {
      'data-automation': 'Business_RetailFinance.topBar.Button',
      href: '/business/retail-finance',
    },
    text: 'Retail Finance',
  },
  {
    attributes: {
      'data-automation': 'Business_AutoFinance.topBar.Button',
      href: '/business/auto-finance',
    },
    text: 'Auto Finance',
  },
  {
    attributes: {
      'data-automation': 'Business_Partnership.topBar.Button',
      href: '/business/partnerships',
    },
    text: 'Partnerships',
  },
  {
    attributes: {
      'data-automation': 'Business_Resources.topBar.Button',
      href: '/business/resources',
    },
    text: 'Resources',
  },
];

export const getNavItems = (isBusiness?: boolean): MenuItem[] => {
  if (isBusiness) {
    return businessNavItems;
  }
  const isB2BEnabled = env('NEXT_PUBLIC_B2B_ENABLED') === 'enabled';
  return isB2BEnabled
    ? personalNavItems.filter((item) => item.attributes?.['data-automation'] !== 'Partnerships.topBar.Menu')
    : personalNavItems;
};
